import { atomWithStorage } from 'jotai/utils';

export const accessStatusAtom = atomWithStorage('userAccessStatus', null);

export const trcUserAtom = atomWithStorage('trcUserData', {});
